import { stateByConsensus } from "@/components/widgets/Revision/lib/helpers";
import { valueColor } from "../../../utils/RevisionTableUtils";

export const coloredTextConsensusTD = (
	value: number | undefined,
	style: string | undefined = undefined,
) => {
	return (
		<td className={`${valueColor(value)} ${style}`}>
			{stateByConsensus(value)}
		</td>
	);
};
